module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/mage-55a05e0a9c27f50718eebcc88e6437c0.png";